export default "__VITE_ASSET__CRXLokGV__"